import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TriggerModeOption } from "../trigger-mode-radio-group/trigger-mode-radio-group.component";

export interface FlowTestCustomerSearchResult {
  id: number;
  label: string;
}

@Component({
  selector: "app-flow-test-customer-section",
  templateUrl: "./flow-test-customer-section.component.html",
  styleUrls: [
    "../app-install/app-install-trigger-form.component.scss",
    "./shared-trigger-section.component.scss",
  ],
})
export class FlowTestCustomerSectionComponent {
  @Input() group!: FormGroup;
  @Input() modeOptions: TriggerModeOption[] = [];
  @Input() requirementLabel = "Optional";
  @Input() userSearchTerm = "";
  @Input() userSearchResults: FlowTestCustomerSearchResult[] = [];
  @Input() userSearchLoading = false;
  @Input() selectedUser: FlowTestCustomerSearchResult | null = null;
  @Input() generateHint =
    "A sandbox customer will be generated using the account's catalog schema.";
  @Input() cloneHint =
    "Search for a real customer to clone into sandbox data. The production customer record will not be modified.";
  @Input() selectedHint =
    "The selected customer's profile/fields will be copied into a sandbox customer for this test. The real customer is never modified.";
  @Input() noneHint =
    "The test runs without a linked customer (anonymous device only). Flow decisions that read customer profile fields will evaluate as unset.";

  @Output() searchInput = new EventEmitter<string>();
  @Output() userPicked = new EventEmitter<FlowTestCustomerSearchResult>();
  @Output() userCleared = new EventEmitter<void>();

  get mode(): string {
    return this.group.get("mode")!.value;
  }
}
